import type { ThgStationRow } from "../../../types/thgAnnualSummary";

/**
 * CLR-288: the table's search. Case-insensitive "contains" on the owner's name, their e-mail and the
 * station ID. Client-side, because the page already holds every station of the year.
 */
export const matchesThgSearch = (row: ThgStationRow, query: string): boolean => {
  const q = query.trim().toLocaleLowerCase();
  if (!q) return true;
  return [row.owner?.name, row.owner?.email, row.stationId].some((value) =>
    value?.toLocaleLowerCase().includes(q),
  );
};

export const filterThgStations = (stations: ThgStationRow[], query: string): ThgStationRow[] =>
  query.trim() ? stations.filter((row) => matchesThgSearch(row, query)) : stations;
